<template>
    <router-view id="page-content-wrapper"></router-view>
</template>

<script>
export default {
    name: "Country"
}
</script>

<style scoped>

</style>